document.addEventListener('DOMContentLoaded', () => {

    let colorContainers = document.querySelectorAll('.color__container');
    let flickityInstances = new Map();

    function showSection(containerSwatches) {
      if (containerSwatches) {
        containerSwatches.classList.remove('color_swatches__container--hidden');
      }
    }

    function initFlickity() {
      colorContainers.forEach((containerSwatches) => {
        const parentContainer = containerSwatches.closest('.color_swatches__container');
        const swatchCount = containerSwatches.querySelectorAll('.swatch_item').length;

        if ( swatchCount <= 4) {
          containerSwatches.classList.add('color__container--no-carousel');
          showSection(parentContainer);
          return;
        }

        if (!flickityInstances.has(containerSwatches)) {
          try {
            const flkty = new Flickity(containerSwatches, {
              cellAlign: 'left',
              prevNextButtons: true,
              pageDots: false,
              draggable: true,
              initialIndex: 0,
              on: {
                ready: function () {
                  showSection(parentContainer);
                },
              },
            });
            flickityInstances.set(containerSwatches, flkty);
          } catch (error) {
            console.error('Error al inicializar Flickity:', error);
          }
        }
      });
    }

    let container = document.getElementById('ProductGridContainer');
    if (!container || container.dataset.infinite !== 'true') return;
  
    let page = 1;
    const maxPages = parseInt(container.dataset.maxPages);
    const batchSize = parseInt(container.dataset.batch);
  
    let grid = container.querySelector('#product-grid');
    let loading = false;

    let lastSearch = window.location.search;

    function resetInfinite() {
        lastSearch = window.location.search;
        page = 0;
        grid.innerHTML = '';
        setTimeout(() => {
            colorContainers = document.querySelectorAll('.color__container');
            flickityInstances = new Map();
            initFlickity()
        }, 1000);
    }

    ['pushState','replaceState'].forEach(method => {
        const orig = history[method];
        history[method] = function(...args) {
          const ret = orig.apply(this, args);
          resetInfinite();
          return ret;
        };
    });
  
    window.addEventListener('scroll', () => {
        
      if (loading) return;
  
      const scrollPos = window.innerHeight + window.scrollY;
      const viewportH = window.innerHeight;
      const isMobile = window.innerWidth <= 768;
      const threshold = isMobile ? viewportH * 1.5 : viewportH * 2;

      if (scrollPos >= document.body.offsetHeight - threshold) {

        const currentSearch = window.location.search;

        if (currentSearch !== lastSearch) {
            resetInfinite();
        }

        if (page >= maxPages) return;
        loading = true;
        page += 1;


        const ajaxEndpoint = `${window.location.pathname}/ajax`;
        const urlSeparator = currentSearch ? '&' : '?';

        const requestUrl = `${ajaxEndpoint}${currentSearch}${urlSeparator}page=${page}&limit=${batchSize}`;

        fetch(requestUrl)
          .then(res => res.text())
          .then(html => {
            const temp = document.createElement('div');
            grid = document.querySelector('#product-grid');
            temp.innerHTML = html;
            temp.querySelectorAll('#product-grid li')
            .forEach(li => {
                grid.appendChild(li)
            });
            setTimeout(() => {
                normalInfo();
                colorContainers = document.querySelectorAll('.color__container');
                flickityInstances = new Map();
                initFlickity()
            }, 1000);
          })
          .catch(console.error)
          .finally(() => loading = false);
      }
    });
  });